function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
import { forwardRef } from "react";
const SvgCircle = (_ref, ref) => {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "100%",
    height: "100%",
    viewBox: "0 0 24 25",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    style: {
      fillRule: "evenodd",
      clipRule: "evenodd",
      strokeLinejoin: "round",
      strokeMiterlimit: 2
    },
    ref: ref,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", {
    transform: "matrix(1,0,0,1,-5578,-711)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "matrix(1,0,0,1,4341.5,0)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "matrix(0.261586,-6.16298e-33,2.15704e-32,0.271636,878.256,477.032)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M1414.54,863.001C1439.04,863.001 1458.93,882.895 1458.93,907.398C1458.93,931.902 1439.04,951.795 1414.54,951.795C1390.03,951.795 1370.14,931.902 1370.14,907.398C1370.14,882.895 1390.03,863.001 1414.54,863.001ZM1414.54,874.072C1396.26,874.072 1381.64,889.118 1381.64,907.398C1381.64,925.679 1396.26,940.724 1414.54,940.724C1432.82,940.724 1447.44,925.679 1447.44,907.398C1447.44,889.118 1432.82,874.072 1414.54,874.072Z",
    style: {
      fill: "white"
    }
  })))));
};
const ForwardRef = /*#__PURE__*/forwardRef(SvgCircle);
export { ForwardRef as ReactComponent };
export default __webpack_public_path__ + "static/media/circle.8f409fc13667513f6692b45a8ebca842.svg";